<template>
  <div>
    <signature-layout
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="title">Affiliate Renewal</span>
      <div
        slot="approvedContent"
        v-if="registration && registration.affiliateRequestData"
      >
        <div class="mt-5">
          <h2>
            <b>{{ registration.affiliateRequestData.name }}</b>
          </h2>
          <h3 class="mt-5">
            <span><b>Website: </b></span>
            <a
              class="no-text-decoration"
              :href="registration.affiliateRequestData.clubsite"
              target="_blank"
              >{{ registration.affiliateRequestData.clubsite }}
            </a>
          </h3>
          <h3 class="mt-5">
            <span><b>Events: </b></span>
            <p>{{ registration.affiliateRequestData.eventsAndActivities }}</p>
          </h3>

          <div
            class="mt-5"
            v-if="registration.affiliateRequestData.lastYearShows"
          >
            <h2>Club shows for renewal year:</h2>
            <p>
              <v-simple-table
                fixed-header
                :height="
                  registration &&
                  registration.affiliateRequestData.lastYearShows
                    ? Math.min(
                        200,
                        (registration.affiliateRequestData.lastYearShows
                          .length +
                          2) *
                          50
                      )
                    : 100
                "
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Show ID</th>
                      <th class="text-left">Date</th>
                      <th class="text-left">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="show in registration.affiliateRequestData
                        .lastYearShows"
                      :key="show.showId"
                    >
                      <td>{{ show.showId }}</td>
                      <td>
                        {{ $dateUtils.formatDate(show.startDate) }} -
                        {{ $dateUtils.formatDate(show.endDate) }}
                      </td>
                      <td>{{ show.type }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </p>
          </div>
          <div class="mt-5">
            <h2>Club members:</h2>
            <p>
              <v-simple-table
                fixed-header
                :height="
                  registration && registration.affiliateRequestData.affMembers
                    ? Math.min(
                        200,
                        (registration.affiliateRequestData.affMembers.length +
                          2) *
                          50
                      )
                    : 100
                "
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Position</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Membership ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="member in registration.affiliateRequestData
                        .affMembers"
                      :key="member.personId"
                    >
                      <td>{{ member.position }}</td>
                      <td>{{ member.firstName }} {{ member.lastName }}</td>
                      <td>{{ member.memberId }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </p>
          </div>
        </div>
      </div>
      <div slot="legalText">
        <p class="bottom-text">
          We the undersigned, apply for membership renewal to the Australian
          Shepherd Club of America as Affiliate Officers of the above named
          club. As official representatives of that affiliate, we agree that our
          club will abide by the <ASCAArtIncLink />, <BylawsLink />, Dispute
          Rules, ASCA Registry Rules and all ASCA programs.
        </p>
      </div>
    </signature-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";

export default Vue.extend({
  name: "AffiliateRegistrationSignatureForm",
  components: {
    SignatureLayout,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    load: async function () {
      this.isLoading = true;

      const response = await workflowService.getAffiliateRenewalDetailsForSignature(this.signatureId);

      this.errorMessage = "";
      this.found = response.found;

      if (response.found && (!response.errors || response.errors.length == 0)) {
        this.registration = response.data;
      } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'

      this.isLoading = false;
    },
    sign: function (workflowGuid: String, signatureId: number, personId: number, text: String) {
      workflowService
        .signAffiliateRenewal(workflowGuid, signatureId, personId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
          this.$router.push("/");
        }).catch(this.$handleError);
    },
  },
});
</script>
